var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "516px",
  height: "1083px",
  viewBox: "0 0 516 1083",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "6DCA7A6A-C6B7-4CBF-A60D-BCDB3DD02ED4")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "newsletter_placeholder",
  transform: "translate(-82.000000, -63.000000)",
  fill: "#E7E7E7"
}, /*#__PURE__*/React.createElement("g", {
  id: "placeholder_all",
  transform: "translate(82.000000, 63.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "placeholder2",
  transform: "translate(0.000000, 279.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37",
  x: 0,
  y: 0,
  width: 516,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy",
  x: -1.62003744e-12,
  y: 32,
  width: 460.216216,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy-2",
  x: -1.62003744e-12,
  y: 64,
  width: 460.216216,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy-4",
  x: 0,
  y: 128,
  width: 516,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy-5",
  x: 1.39266376e-12,
  y: 160,
  width: 306.810811,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy-7",
  x: 0,
  y: 224,
  width: 516,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy-8",
  x: -7.10542736e-13,
  y: 256,
  width: 491.096525,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy-9",
  x: 0,
  y: 288,
  width: 516,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy-10",
  x: -1.13686838e-12,
  y: 320,
  width: 476.15444,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy-11",
  x: -5.40012479e-13,
  y: 352,
  width: 368.571429,
  height: 20
})), /*#__PURE__*/React.createElement("g", {
  id: "placeholder3",
  transform: "translate(0.000000, 711.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37",
  x: 0,
  y: 0,
  width: 516,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy",
  x: -1.62003744e-12,
  y: 32,
  width: 460.216216,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy-2",
  x: -1.62003744e-12,
  y: 64,
  width: 460.216216,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy-4",
  x: 0,
  y: 128,
  width: 516,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy-5",
  x: 1.39266376e-12,
  y: 160,
  width: 306.810811,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy-7",
  x: 0,
  y: 224,
  width: 516,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy-8",
  x: -7.10542736e-13,
  y: 256,
  width: 491.096525,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy-9",
  x: 0,
  y: 288,
  width: 516,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy-10",
  x: -1.13686838e-12,
  y: 320,
  width: 476.15444,
  height: 20
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-37-Copy-11",
  x: -5.40012479e-13,
  y: 352,
  width: 368.571429,
  height: 20
})), /*#__PURE__*/React.createElement("g", {
  id: "placeholder1",
  transform: "translate(59.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-5",
  x: 116,
  y: 30,
  width: 166,
  height: 27
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-5-Copy",
  x: -5.68434189e-14,
  y: 88,
  width: 399,
  height: 32
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-5-Copy-2",
  x: 62,
  y: 133,
  width: 274,
  height: 32
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-5-Copy-9",
  x: 123,
  y: 0,
  width: 152,
  height: 18
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-5-Copy",
  x: 149,
  y: 201,
  width: 101,
  height: 18
})))))));
export default SvgPlaceholder;